import LockIcon from '@mui/icons-material/Lock';
import '../../pages/pages.scss';

const NoAccess = ({title, info}) => {
    return (
        <div className={'noAccess'}>
            <p>{ title && info && (<LockIcon sx={{
                fontSize: 'small'
            }} />)} {(title && title) || ""}</p>
            <p class="note">{(info && info) || ""}</p>
        </div>
    );
};

export default NoAccess;